
import { database, firestore, auth } from './firebaseConfig';
import { ref, get, set, update, push, remove, query } from 'firebase/database';
import { collection, doc, getDoc, setDoc, updateDoc, getDocs, addDoc, deleteDoc, writeBatch, where, orderBy, onSnapshot, increment, Timestamp, runTransaction } from 'firebase/firestore';
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  updatePassword,
  getAuth,
  signOut as authSignOut 
} from 'firebase/auth';
import { generateStudentId } from './utils';
import { getFunctions, httpsCallable } from 'firebase/functions';  // Import thêm
import { app } from './firebaseConfig';  // Giả định đã có app
import { getApps, initializeApp } from 'firebase/app';

const classMap = {
  'to-mau': 'Tô Màu',
  'khai-tam-1a-nu': 'Khai Tâm 1A Nữ',
  'khai-tam-1b-nam': 'Khai Tâm 1B Nam',
  'khai-tam-2a-nu': 'Khai Tâm 2A Nữ',
  'khai-tam-2b-nu': 'Khai Tâm 2B Nữ',
  'khai-tam-2c-nam': 'Khai Tâm 2C Nam',
  'khai-tam-2d-nam': 'Khai Tâm 2D Nam',
  'ruoc-le-1a-nu': 'Rước Lễ 1A Nữ',
  'ruoc-le-1b-nu': 'Rước Lễ 1B Nữ',
  'ruoc-le-1c-nam': 'Rước Lễ 1C Nam',
  'ruoc-le-1d-nam': 'Rước Lễ 1D Nam',
  // 'ruoc-le-2a-nu': 'Rước Lễ 2A Nữ',
  // 'ruoc-le-2b-nu': 'Rước Lễ 2B Nữ',
  'ruoc-le-2ab-nu': 'Rước Lễ 2AB Nữ',
  'ruoc-le-2c-nam': 'Rước Lễ 2C Nam',
  'ruoc-le-2d-nam': 'Rước Lễ 2D Nam',
  'them-suc-1a-nu': 'Thêm Sức 1A Nữ',
  'them-suc-1b-nu': 'Thêm Sức 1B Nữ',
  'them-suc-1c-nam': 'Thêm Sức 1C Nam',
  'them-suc-1d-nam': 'Thêm Sức 1D Nam',
  'them-suc-2a-nu': 'Thêm Sức 2A Nữ',
  'them-suc-2b-nu': 'Thêm Sức 2B Nữ',
  // 'them-suc-2c-nam': 'Thêm Sức 2C Nam',
  // 'them-suc-2d-nam': 'Thêm Sức 2D Nam',
  'them-suc-2cd-nam': 'Thêm Sức 2CD Nam',
  'bao-dong-1a-nu': 'Bao Đồng 1A Nữ',
  'bao-dong-1b-nam': 'Bao Đồng 1B Nam',
  'bao-dong-2a-nu': 'Bao Đồng 2A Nữ',
  'bao-dong-2b-nam': 'Bao Đồng 2B Nam',
  'bao-dong-3': 'Bao Đồng 3',
  'bao-dong-4': 'Bao Đồng 4',
  'du-bi-giao-ly-vien': 'Dự Bị Giáo Lý Viên',
};

let cachedData = null;
let cachedTranscripts = null;
let cachedCatechismData = null;
let cachedCatechists = null;

export const login = async (username, password, retries = 3) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      // console.log(`FirebaseService.login - Attempt ${attempt} - Checking credentials for username: ${username}`);
      let email = username;

      if (!username.includes('@')) {
        email = `${username}@thieunhigiaoxuannhon.com`;
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          throw new Error('Định dạng email không hợp lệ');
        }
      }

      console.log(`Attempting login with email: ${email}`);
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const staffDoc = doc(firestore, `staff/${user.uid}`);
      const staffSnapshot = await getDoc(staffDoc);
      if (!staffSnapshot.exists()) {
        // console.log(`FirebaseService.login - No matching staff data found for UID: ${user.uid}`);
        await signOut(auth);
        return { success: false, message: 'Tài khoản không tồn tại trong hệ thống. UID: ' + user.uid };
      }

      const staffData = staffSnapshot.data();
      // console.log('FirebaseService.login - Login successful, storing user data');
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('catechistFullName', staffData.fullName);
      localStorage.setItem('username', username);
      localStorage.setItem('catechistHolyName', staffData.holyName || '');
      localStorage.setItem('catechistClassName', staffData.className || '');
      localStorage.setItem('userRole', staffData.role || 'catechist');
      localStorage.setItem('blockLeader', staffData.blockLeader || '');
      localStorage.setItem('departmentLeader', staffData.departmentLeader || '');
      localStorage.setItem('uid', user.uid);

      localStorage.setItem('userRole', staffData.role || 'catechist');
      localStorage.setItem('blockLeader', staffData.blockLeader || '');
      localStorage.setItem('departmentLeader', staffData.departmentLeader || '');
      localStorage.setItem('uid', user.uid);
      
      // 🌟 THÊM 2 DÒNG NÀY ĐỂ ĐỒNG BỘ GIỚI TÍNH & CHỨC DANH TU SĨ / GLV:
      localStorage.setItem('gender', staffData.gender || 'Nam');
      localStorage.setItem('religious', staffData.religious || 'Giáo lý viên');

      return {
        success: true,
        fullName: staffData.fullName,
        holyName: staffData.holyName,
        className: staffData.className,
        role: staffData.role,
        blockLeader: staffData.blockLeader,
        departmentLeader: staffData.departmentLeader,
      };
    } catch (error) {
      console.error(`Attempt ${attempt} failed:`, error);
      if (attempt === retries) {
        let message = 'Sai tên đăng nhập hoặc mật khẩu';
        if (error.code === 'auth/invalid-email') {
          message = 'Định dạng email không hợp lệ';
        } else if (error.code === 'auth/invalid-credential') {
          message = 'Tên đăng nhập hoặc mật khẩu không đúng';
        } else if (error.code === 'auth/too-many-requests') {
          message = 'Quá nhiều lần thử đăng nhập. Vui lòng thử lại sau';
        } else if (error.code === 'auth/network-request-failed') {
          message = 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối của bạn';
        }
        return { success: false, message };
      }
      await new Promise(resolve => setTimeout(resolve, 2000 * attempt));
    }
  }
};

export const fetchCatechistProfile = async (uid) => {
  try {
    const staffDoc = doc(firestore, `staff/${uid}`);
    const staffSnapshot = await getDoc(staffDoc);
    if (staffSnapshot.exists()) {
      return { success: true, data: staffSnapshot.data() };
    } else {
      return { success: false, message: 'Không tìm thấy thông tin giáo lý viên' };
    }
  } catch (error) {
    console.error('Error fetching catechist profile:', error);
    return { success: false, message: 'Lỗi khi lấy thông tin giáo lý viên' };
  }
};

// Nếu cần, thêm hàm riêng để update access
export const updateChurchAttendanceAccess = async (uid, access) => {
  try {
    const staffDoc = doc(firestore, `staff/${uid}`);
    await updateDoc(staffDoc, { churchAttendanceAccess: access });
    cachedCatechists = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating church attendance access:', error);
    throw error;
  }
};

export const addCatechistWithAuth = async (catechistData) => {
  try {
    console.log('FirebaseService.addCatechistWithAuth - Adding catechist:', catechistData);
    const email = `${catechistData.username}@thieunhigiaoxuannhon.com`;
    const password = catechistData.password || 'Annhon@1965';

    // 1. Tạo hoặc tái sử dụng instance Firebase App phụ để không ảnh hưởng phiên đăng nhập chính
    const secondaryApp = getApps().find((a) => a.name === 'SecondaryAuthApp') 
      || initializeApp(app.options, 'SecondaryAuthApp');
    const secondaryAuth = getAuth(secondaryApp);

    // 2. Tạo tài khoản thông qua auth của App phụ
    const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
    const newUser = userCredential.user;

    // 3. Đăng xuất ngay khỏi Auth phụ để dọn sạch phiên tạm
    await authSignOut(secondaryAuth);

    // 4. Lưu hồ sơ vào Firestore (dùng firestore của App chính với quyền Admin hiện tại)
    const dataToSave = {
      username: catechistData.username,
      fullName: catechistData.fullName,
      holyName: catechistData.holyName,
      idCode: catechistData.idCode,
      gender: catechistData.gender || 'Nam',
      religious: catechistData.religious || 'Giáo lý viên',
      className: catechistData.className || '',
      blockLeader: catechistData.blockLeader || '',
      departmentLeader: catechistData.departmentLeader || '',
      role: catechistData.role || 'catechist',
      status: 'active',
      passwordChangeCount: 0,
      lastPasswordChange: null
    };

    const staffDoc = doc(firestore, `staff/${newUser.uid}`);
    await setDoc(staffDoc, dataToSave);
    cachedCatechists = null;

    return { success: true, uid: newUser.uid };
  } catch (error) {
    console.error('Error adding catechist with auth:', error);
    throw error;
  }
};

export const addCatechist = async (catechistData) => {
  try {
    console.log('FirebaseService.addCatechist - Adding catechist:', catechistData);
    const staffDoc = doc(firestore, `staff/${catechistData.idCode}`);

    const dataToSave = {
      username: catechistData.username,
      fullName: catechistData.fullName,
      holyName: catechistData.holyName,
      idCode: catechistData.idCode,
      gender: catechistData.gender || 'Nam',               // 🌟 Mới
      religious: catechistData.religious || 'Giáo lý viên', // 🌟 Mới
      className: catechistData.className || '',
      blockLeader: catechistData.blockLeader || '',
      departmentLeader: catechistData.departmentLeader || '',
      role: catechistData.role || 'catechist',
      status: 'active',
    };

    await setDoc(staffDoc, dataToSave);
    cachedCatechists = null;
    return { success: true };
  } catch (error) {
    console.error('Error adding catechist:', error);
    throw error;
  }
};

export const updateCatechist = async (uid, updates) => {
  try {
    console.log('FirebaseService.updateCatechist - Updating catechist:', { uid, updates });
    const staffDoc = doc(firestore, `staff/${uid}`);

    await updateDoc(staffDoc, updates);
    cachedCatechists = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating catechist:', error);
    throw error;
  }
};

export const updateAttendance = async (studentId, catechistFullName) => {
  const date = new Date().toLocaleDateString('sv-SE');

  try {
    const attendanceRef = ref(database, `attendance/${date}`);
    const time = new Date().toLocaleTimeString('vi-VN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    await update(attendanceRef, { [studentId]: { time_log: new Date(), time: `Có lúc ${time}`, catechist: `${catechistFullName}` } });
    cachedData = null;
    return true;
  } catch (error) {
    console.error('Error updating attendance:', error);
    return false;
  }
};

export const updateChurchAttendance = async (studentId, date, status, catechistFullName) => {
  try {
    const attendanceRef = ref(database, `attendance/${date}`);
    await update(attendanceRef, { [studentId]: { time_log: new Date(), time: status, catechist: `${catechistFullName}` } });
    cachedData = null;
    return true;
  } catch (error) {
    console.error('Error updating church attendance:', error);
    throw error;
  }
};

export const updateCatechismAttendance = async (studentId, date, status, catechistFullName) => {
  try {
    const catechismAttendanceRef = ref(database, `catechismAttendance/${date}`);
    await update(catechismAttendanceRef, { [studentId]: { time_log: new Date(), time: status, catechist: `${catechistFullName}` } });
    cachedCatechismData = null;
    return true;
  } catch (error) {
    console.error('Error updating catechism attendance:', error);
    throw error;
  }
};

export const fetchStudentName = async (studentId) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    const snapshot = await get(studentRef);
    const student = snapshot.val();
    return student ? student.fullName : 'Lỗi';
  } catch (error) {
    console.error('Error fetching student name:', error);
    return 'Lỗi';
  }
};

export const fetchAllDataFromSheets = async () => {
  if (cachedData) {
    // console.log('Returning cached data');
    return cachedData;
  }

  try {
    // console.log('Fetching all data from Firebase');
    const studentsRef = ref(database, 'students');
    const attendanceRef = ref(database, 'attendance');
    const [studentsSnapshot, attendanceSnapshot] = await Promise.all([
      get(studentsRef),
      get(attendanceRef)
    ]);

    const students = studentsSnapshot.val() || {};
    const attendance = attendanceSnapshot.val() || {};

    const studentList = Object.keys(students).map(id => ({
      id,
      ...students[id]
    }));

    const attendanceList = studentList.map(student => {
      const studentAttendance = {};
      Object.keys(attendance).forEach(date => {
        if (attendance[date][student.id]) {
          studentAttendance[date] = attendance[date][student.id];
        }
      });
      return { id: student.id, attendance: studentAttendance };
    });

    const dates = Object.keys(attendance).sort();

    const data = { students: studentList, attendance: attendanceList, dates };
    cachedData = data;
    return data;
  } catch (error) {
    console.error('Error fetching all data:', error);
    return { students: [], attendance: [], dates: [] };
  }
};

export const fetchAllTranscripts = async () => {
  if (cachedTranscripts) {
    // console.log('Returning cached transcripts');
    return cachedTranscripts;
  }

  try {
    // console.log('Fetching all transcripts from Firebase');
    const transcriptsRef = ref(database, 'transcripts');
    const snapshot = await get(transcriptsRef);
    const transcriptsData = snapshot.val() || {};

    const transcripts = [];
    for (const classId in transcriptsData) {
      for (const studentId in transcriptsData[classId]) {
        transcripts.push({
          className: classMap[classId] || classId,
          id: studentId,
          semester1: transcriptsData[classId][studentId].semester1 || {},
          semester2: transcriptsData[classId][studentId].semester2 || {},
          yearly: transcriptsData[classId][studentId].yearly || {}
        });
      }
    }

    cachedTranscripts = transcripts;
    return transcripts;
  } catch (error) {
    // console.error('Error fetching all transcripts:', error);
    return [];
  }
};

export const fetchTranscript = async (classId) => {
  try {
    // TRƯỜNG HỢP 1: Lấy tất cả các lớp
    if (classId === 'all') {
      // console.log('FirebaseService.fetchTranscript - Fetching ALL classes');
      const transcriptsRef = ref(database, 'transcripts');
      const snapshot = await get(transcriptsRef);
      const allData = snapshot.val() || {};

      const combinedTranscripts = {};

      // Duyệt qua từng lớp (classId)
      Object.keys(allData).forEach(clsId => {
        const classData = allData[clsId];
        // Duyệt qua từng học sinh (studentId) trong lớp đó
        Object.keys(classData).forEach(studentId => {
          // Gộp vào object chung. Lưu ý: Nếu một học sinh học 2 lớp (hiếm), dữ liệu sau sẽ đè trước
          combinedTranscripts[studentId] = {
            semester1: classData[studentId].semester1 || {},
            semester2: classData[studentId].semester2 || {},
            yearly: classData[studentId].yearly || {}
          };
        });
      });

      return combinedTranscripts;
    }

    // TRƯỜNG HỢP 2: Lấy 1 lớp cụ thể (Logic cũ giữ nguyên)
    // console.log('FirebaseService.fetchTranscript - Fetching transcript for classId:', classId);
    const normalizedClassId = classMap[classId] || classId;
    const transcriptsRef = ref(database, `transcripts/${classId}`);
    const snapshot = await get(transcriptsRef);
    const transcriptData = snapshot.val() || {};

    const transcript = {};
    for (const studentId in transcriptData) {
      transcript[studentId] = {
        semester1: transcriptData[studentId].semester1 || {},
        semester2: transcriptData[studentId].semester2 || {},
        yearly: transcriptData[studentId].yearly || {}
      };
    }

    return transcript;
  } catch (error) {
    console.error('Error fetching transcript:', error);
    return {};
  }
};

export const fetchStudentListByClass = async (className) => {
  const data = await fetchAllDataFromSheets();
  const students = data.students
    .filter((student) => student.className === className)
    .map((student) => ({
      id: student.id || '',
      holyName: student.holyName || '',
      fullName: student.fullName || '',
    }));
  return students;
};

export const fetchAttendanceByClass = async (className) => {
  const data = await fetchAllDataFromSheets();
  const attendance = data.attendance
    .filter((att) => {
      const student = data.students.find((s) => s.id === att.id);
      return student && student.className === className;
    })
    .map((att) => ({
      id: att.id,
      attendance: att.attendance,
    }));
  return {
    dates: data.dates,
    attendance,
  };
};

export const fetchAllCatechismAttendance = async () => {
  if (cachedCatechismData) {
    // console.log('Returning cached catechism attendance');
    return cachedCatechismData;
  }

  try {
    // console.log('Fetching all catechism attendance from Firebase');
    const catechismAttendanceRef = ref(database, 'catechismAttendance');
    const snapshot = await get(catechismAttendanceRef);
    const catechismAttendanceData = snapshot.val() || {};

    const studentsRef = ref(database, 'students');
    const studentsSnapshot = await get(studentsRef);
    const students = studentsSnapshot.val() || {};

    const studentList = Object.keys(students).map(id => ({
      id,
      className: students[id].className || ''
    }));

    const attendanceList = studentList.map(student => {
      const studentCatechismAttendance = {};
      Object.keys(catechismAttendanceData).forEach(date => {
        if (catechismAttendanceData[date][student.id]) {
          studentCatechismAttendance[date] = catechismAttendanceData[date][student.id];
        }
      });
      return {
        id: student.id,
        className: student.className,
        attendance: studentCatechismAttendance
      };
    });

    const dates = Object.keys(catechismAttendanceData).sort();

    const data = { dates, attendance: attendanceList };
    cachedCatechismData = data;
    // console.log('Fetched catechism attendance data:', data);
    return data;
  } catch (error) {
    console.error('Error fetching all catechism attendance:', error);
    return { dates: [], attendance: [] };
  }
};

export const fetchCatechismAttendanceByClass = async (className) => {
  try {
    if (!cachedCatechismData) {
      console.log('No cached catechism data, fetching all catechism attendance');
      cachedCatechismData = await fetchAllCatechismAttendance();
    }

    const filteredAttendance = cachedCatechismData.attendance
      .filter((att) => att.className === className)
      .map((att) => ({
        id: att.id,
        attendance: att.attendance,
      }));

    return {
      dates: cachedCatechismData.dates,
      attendance: filteredAttendance,
    };
  } catch (error) {
    console.error('Error fetching catechism attendance:', error);
    return { dates: [], attendance: [] };
  }
};

export const fetchStudentQRCode = async (studentId) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    const snapshot = await get(studentRef);
    const student = snapshot.val();
    return student?.qrCode || null;
  } catch (error) {
    console.error('Error fetching student QR code:', error);
    return null;
  }
};

export const updateStudentStatus = async (studentId, status) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    await update(studentRef, { status });
    cachedData = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating student status:', error);
    throw error;
  }
};

export const updateStudentDateOfBirth = async (studentId, dateOfBirth) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    await update(studentRef, { dateOfBirth });
    cachedData = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating student date of birth:', error);
    throw error;
  }
};

export const changePassword = async (currentPassword, newPassword) => {
  const user = auth.currentUser;
  if (!user) {
    return { success: false, message: 'Không có người dùng đang đăng nhập' };
  }

  try {
    const credential = EmailAuthProvider.credential(user.email, currentPassword);
    await reauthenticateWithCredential(user, credential);
    await updatePassword(user, newPassword);

    // Cập nhật Firestore: Tăng count và update thời gian
    const staffDoc = doc(firestore, `staff/${user.uid}`);
    await updateDoc(staffDoc, {
      passwordChangeCount: increment(1),  // Tăng count lên 1
      lastPasswordChange: Timestamp.now()  // Update thời gian hiện tại
    });

    // Invalidate cache nếu cần
    cachedCatechists = null;

    return { success: true, message: 'Đổi mật khẩu thành công' };
  } catch (error) {
    console.error('Error changing password:', error);
    let message = 'Lỗi khi đổi mật khẩu';
    if (error.code === 'auth/wrong-password') {
      message = 'Mật khẩu hiện tại không đúng';
    } else if (error.code === 'auth/weak-password') {
      message = 'Mật khẩu mới quá yếu';
    }
    return { success: false, message };
  }
};

export const updateTranscript = async (classId, transcriptData) => {
  try {
    console.log('FirebaseService.updateTranscript - Class ID:', classId);
    const transcriptsRef = ref(database, `transcripts/${classId}`);
    await set(transcriptsRef, transcriptData);
    cachedTranscripts = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating transcript:', error);
    throw error;
  }
};

export const fetchTranscriptLockStatus = async (classId) => {
  try {
    const lockRef = ref(database, `transcriptLockStatus/${classId}`);
    const snapshot = await get(lockRef);
    return snapshot.val() || false;
  } catch (error) {
    console.error('Error fetching transcript lock status:', error);
    throw error;
  }
};

export const updateTranscriptLockStatus = async (classId, isLocked) => {
  try {
    const lockRef = ref(database, `transcriptLockStatus/${classId}`);
    await set(lockRef, isLocked);
    return { success: true };
  } catch (error) {
    console.error('Error updating transcript lock status:', error);
    throw error;
  }
};

export const fetchAllTranscriptLocks = async () => {
  try {
    const locksRef = ref(database, 'transcriptLocks');
    const snapshot = await get(locksRef);
    return snapshot.val() || {};
  } catch (error) {
    console.error('Error fetching all transcript locks:', error);
    throw error;
  }
};

export const fetchTranscriptLocks = async (classId) => {
  try {
    const locksRef = ref(database, `transcriptLocks/${classId}`);
    const snapshot = await get(locksRef);
    return snapshot.val() || { semester1: {}, semester2: {} };
  } catch (error) {
    console.error('Error fetching transcript locks:', error);
    throw error;
  }
};

export const updateTranscriptLock = async (classId, semester, field, isLocked) => {
  try {
    const lockRef = ref(database, `transcriptLocks/${classId}/${semester}/${field}`);
    await set(lockRef, isLocked);
    return { success: true };
  } catch (error) {
    console.error('Error updating transcript lock:', error);
    throw error;
  }
};

export const fetchAllCatechists = async () => {
  if (cachedCatechists) {
    console.log('Returning cached catechists');
    return cachedCatechists;
  }

  try {
    console.log('Fetching all catechists from Firestore');
    const staffCollection = collection(firestore, 'staff');
    const snapshot = await getDocs(staffCollection);
    const catechists = snapshot.docs.map(doc => ({
      uid: doc.id,
      ...doc.data(),
    }));

    cachedCatechists = catechists;
    return catechists;
  } catch (error) {
    console.error('Error fetching all catechists:', error);
    return [];
  }
};

export const addNewStudent = async (studentData) => {
  try {
    const studentCount = await fetchStudentCount();
    const newId = generateStudentId(studentData.holyName, studentData.fullName, studentCount.count);

    const studentPath = `students/${newId}`;
    await writeData(studentPath, {
      holyName: studentData.holyName,
      fullName: studentData.fullName,
      className: studentData.className,
      classNameId: studentData.classNameId,
      dateOfBirth: studentData.dateOfBirth,
      status: studentData.status || 'Còn đi học',
    });
    return { success: true, message: 'Đã thêm thiếu nhi thành công', id: newId, ...studentData };
  } catch (error) {
    console.error('Error adding new student:', error);
    throw error;
  }
};

export const writeData = async (path, data) => {
  try {
    const dbRef = ref(database, path);
    await set(dbRef, data);
    return { success: true, message: 'Data written successfully' };
  } catch (error) {
    console.error(`Error writing data to ${path}:`, error);
    throw error;
  }
};

export const fetchStudentCount = async () => {
  try {
    console.log('Fetching student count from Firebase');
    const studentsRef = ref(database, 'students');
    const snapshot = await get(studentsRef);
    const students = snapshot.val() || {};
    return { success: true, count: Object.keys(students).length };
  } catch (error) {
    console.error('Error fetching student count:', error);
    throw error;
  }
};

export const signOut = async () => {
  try {
    console.log('FirebaseService.logout - Signing out user');
    await signOut(auth); // Sign out từ Firebase
    localStorage.clear(); // Xóa toàn bộ localStorage
    console.log('Logout successful');
    return { success: true };
  } catch (error) {
    console.error('Error during logout:', error);
    return { success: false, message: 'Đăng xuất thất bại' };
  }
};

// Fetch all events từ RTDB
export const fetchAllEvents = async () => {
  try {
    const eventsRef = ref(database, 'events');
    const snapshot = await get(eventsRef);
    const eventsData = snapshot.val() || {};
    // Convert object {key: data} thành array [{id: key, ...data}]
    return Object.entries(eventsData).map(([id, data]) => ({ id, ...data }));
  } catch (error) {
    console.error('Error fetching events:', error);
    return [];
  }
};

// Add new event (sử dụng push để tạo key unique)
export const addEvent = async (eventData) => {
  try {
    const eventsRef = ref(database, 'events');
    const newEventRef = push(eventsRef); // Tạo ref mới với key unique
    await set(newEventRef, eventData); // Lưu data
    return { success: true, id: newEventRef.key };
  } catch (error) {
    console.error('Error adding event:', error);
    throw error;
  }
};

// Update event
export const updateEvent = async (eventId, updates) => {
  try {
    const eventRef = ref(database, `events/${eventId}`);
    await update(eventRef, updates);
    return { success: true };
  } catch (error) {
    console.error('Error updating event:', error);
    throw error;
  }
};

// Delete event
export const deleteEvent = async (eventId) => {
  try {
    const eventRef = ref(database, `events/${eventId}`);
    await remove(eventRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting event:', error);
    throw error;
  }
};

export const fetchStudentRewards = async (studentId) => {
  try {
    const rewardsRef = ref(database, `rewards/${studentId}`);
    const snapshot = await get(rewardsRef);
    return snapshot.val() || {};
  } catch (error) {
    console.error('Error fetching student rewards:', error);
    return {};
  }
};

export const fetchStudentInfo = async (studentId) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    const snapshot = await get(studentRef);
    const student = snapshot.val();
    if (!student) {
      return { error: 'Không tìm thấy thiếu nhi' };
    }
    return {
      holyName: student.holyName || '',
      fullName: student.fullName || '',
    };
  } catch (error) {
    console.error('Error fetching student info:', error);
    return { error: 'Lỗi khi lấy thông tin' };
  }
};

export const updateQuizReward = async (studentId) => {
  const today = new Date().toLocaleDateString('sv-SE');
  try {
    const rewardRef = ref(database, `rewards/${studentId}/${today}`);
    const snapshot = await get(rewardRef);
    const existingRewards = snapshot.val() || {};
    if (existingRewards.quiz_star) {
      return { success: false, message: 'Bạn đã nhận thưởng đố vui hôm nay rồi.' };
    }
    await update(rewardRef, { quiz_star: 1 });
    return { success: true };
  } catch (error) {
    console.error('Error updating quiz reward:', error);
    return { success: false, message: 'Lỗi khi cập nhật thưởng.' };
  }
};

// Note: Update the existing updateDailyReward to use daily_star instead of star for consistency
export const updateDailyReward = async (studentId) => {
  const today = new Date().toLocaleDateString('sv-SE');
  try {
    const rewardRef = ref(database, `rewards/${studentId}/${today}`);
    const snapshot = await get(rewardRef);
    const existingRewards = snapshot.val() || {};
    if (existingRewards.daily_star) {
      return { success: false, message: 'Bạn đã nhận thưởng hàng ngày hôm nay rồi.' };
    }
    await update(rewardRef, { daily_star: 1 });
    return { success: true };
  } catch (error) {
    console.error('Error updating daily reward:', error);
    return { success: false, message: 'Lỗi khi cập nhật thưởng.' };
  }
};

export const getQuizAttempts = async (studentId) => {
  const today = new Date().toLocaleDateString('sv-SE');
  try {
    const rewardRef = ref(database, `rewards/${studentId}/${today}`);
    const snapshot = await get(rewardRef);
    const existing = snapshot.val() || {};
    return existing.quiz_attempts || 0;
  } catch (error) {
    console.error('Error getting quiz attempts:', error);
    return 0;
  }
};

export const updateQuizScore = async (studentId, score) => {
  const today = new Date().toLocaleDateString('sv-SE');
  try {
    const rewardRef = ref(database, `rewards/${studentId}/${today}`);
    const snapshot = await get(rewardRef);
    const existing = snapshot.val() || {};
    let attempts = existing.quiz_attempts || 0;
    if (attempts >= 3) {
      return { success: false, message: 'Bạn đã hết lượt chơi hôm nay.' };
    }
    let currentStars = existing.quiz_stars || 0;
    currentStars += score;
    attempts += 1;
    await update(rewardRef, { quiz_stars: currentStars, quiz_attempts: attempts });
    return { success: true, added: score };
  } catch (error) {
    console.error('Error updating quiz score:', error);
    return { success: false, message: 'Lỗi khi cập nhật điểm.' };
  }
};

export const updateStudentHolyName = async (studentId, holyName) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    await update(studentRef, { holyName });
    cachedData = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating student holy name:', error);
    throw error;
  }
};

export const updateStudentClass = async (studentId, newClassName, newClassId) => {
  try {
    const studentRef = ref(database, `students/${studentId}`);
    await update(studentRef, { className: newClassName, classNameId: newClassId });
    cachedData = null; // Clear cache if necessary
    return { success: true };
  } catch (error) {
    console.error('Error updating student class:', error);
    throw error;
  }
};

// For Bổ sung điểm danh đi lễ (church attendance)
export const supplementalAttendance = async (studentId, catechist, date, time, time_log) => {
  try {
    const attendanceRef = ref(database, `attendance/${date}/${studentId}`);
    await set(attendanceRef, { time, catechist, time_log });
    cachedData = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating attendance:', error);
    return { success: false, message: 'Lỗi khi bổ sung điểm danh đi lễ' };
  }
};

// For Bổ sung điểm danh học giáo lý (catechism attendance)
export const supplementalCatechismAttendance = async (studentId, catechist, date, time, time_log) => {
  try {
    const attendanceRef = ref(database, `catechismAttendance/${date}/${studentId}`);
    await set(attendanceRef, { time, catechist, time_log });
    cachedCatechismData = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating catechism attendance:', error);
    return { success: false, message: 'Lỗi khi bổ sung điểm danh học giáo lý' };
  }
};

const functions = getFunctions(app);

export const deleteCatechist = async (uid) => {
  try {
    const deleteUserFunc = httpsCallable(functions, 'deleteUser');
    const result = await deleteUserFunc({ uid });
    if (result.data.success) {
      await deleteDoc(doc(firestore, `staff/${uid}`));
      cachedCatechists = null;
      return { success: true };
    } else {
      return { success: false, message: result.data.message || 'Lỗi khi xóa từ Authentication' };
    }
  } catch (error) {
    console.error('Error deleting catechist:', error);
    return { success: false, message: error.message };
  }
};

export const fetchAllRewards = async () => {
  try {
    const rewardsRef = ref(database, 'rewards');
    const snapshot = await get(rewardsRef);
    return snapshot.val() || {};
  } catch (error) {
    console.error('Error fetching all rewards:', error);
    return {};
  }
};

export const createSingleAttendanceRecord = async (data) => {
  try {
    const docRef = await addDoc(collection(firestore, 'catechist_attendance'), {
      ...data,
      uploadedAt: Timestamp.now() // Bạn nhớ import Timestamp nhé
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// --- QUẢN LÝ KHÓA/MỞ CỘT NGÀY ---
export const fetchDateLocks = async () => {
  try {
    const docSnap = await getDoc(doc(firestore, 'settings', 'attendance_locks'));
    if (docSnap.exists()) return docSnap.data();
    return {};
  } catch (error) {
    console.error('Lỗi khi tải trạng thái khóa:', error);
    return {};
  }
};

export const updateDateLockStatus = async (date, isLocked) => {
  try {
    await setDoc(doc(firestore, 'settings', 'attendance_locks'), {
      [date]: isLocked
    }, { merge: true }); // Dùng merge để không ghi đè mất các ngày khác
    return true;
  } catch (error) {
    console.error('Lỗi khi khóa/mở ngày:', error);
    return false;
  }
};

// --- QUẢN LÝ NGÀY CÓ HỌP ---
export const fetchMeetingDates = async () => {
  try {
    const docSnap = await getDoc(doc(firestore, 'settings', 'attendance_meetings'));
    if (docSnap.exists()) return docSnap.data();
    return {};
  } catch (error) {
    console.error('Lỗi khi tải trạng thái ngày họp:', error);
    return {};
  }
};

/**
 * Lắng nghe danh sách Ngày Có Họp theo Niên khóa thời gian thực
 */
export const subscribeMeetingDates = (yearId, callback) => {
  if (!yearId) return () => {};
  const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_meetings');
  return onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback(snap.data() || {});
    } else {
      callback({});
    }
  }, (err) => {
    console.error('Lỗi lắng nghe ngày họp:', err);
  });
};

/**
 * Cập nhật trạng thái ngày có họp vào Firestore theo Niên khóa
 */
export const updateMeetingDateStatus = async (yearId, dateStr, hasMeeting) => {
  try {
    if (!yearId || !dateStr) return false;
    const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_meetings');
    await setDoc(docRef, {
      [dateStr]: Boolean(hasMeeting)
    }, { merge: true });
    return true;
  } catch (error) {
    console.error('Lỗi khi cập nhật ngày họp:', error);
    return false;
  }
};

// --- QUẢN LÝ ĐIỂM DANH GIÁO LÝ VIÊN (TỪ EXCEL) ---

export const uploadCatechistAttendanceData = async (catechistList) => {
  try {
    const batch = writeBatch(firestore);

    catechistList.forEach((catechist) => {
      // Dùng STT từ Excel làm Document ID
      const docRef = doc(firestore, 'catechist_attendance', String(catechist.id));

      batch.set(docRef, {
        'Họ và tên': catechist['Họ và tên'], // Tên đã được ghép ở bước parse
        'Khối': catechist['Khối'],
        'attendance': catechist.attendance, // Lưu dưới dạng mảng (Array)
        'lastUpdated': Timestamp.now()
      }); // KHÔNG dùng merge: true ở đây để ghi đè sạch dữ liệu cũ
    });

    await batch.commit();
    return { success: true, message: `Đã tải lên ${catechistList.length} giáo lý viên!` };
  } catch (error) {
    console.error('Lỗi upload:', error);
    return { success: false, message: error.message };
  }
};

export const fetchCatechistAttendanceData = async () => {
  try {
    const attendanceCollection = collection(firestore, 'catechist_attendance');
    const snapshot = await getDocs(attendanceCollection);
    return snapshot.docs.map(doc => ({
      id: doc.id, // Đây chính là STT
      ...doc.data()
    }));
  } catch (error) {
    console.error('Lỗi khi lấy dữ liệu:', error);
    return [];
  }
};

// Thay thế hàm updateSingleAttendanceRecord cũ bằng hàm này
export const updateCatechistAttendanceArray = async (docId, newAttendanceArray) => {
  try {
    const docRef = doc(firestore, 'catechist_attendance', String(docId));

    // Đẩy toàn bộ Mảng (Array) mới lên ghi đè mảng cũ để bảo toàn cấu trúc
    await updateDoc(docRef, {
      attendance: newAttendanceArray,
      lastUpdated: Timestamp.now()
    });
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi cập nhật mảng điểm danh:', error);
    return { success: false, message: error.message };
  }
};

// Thêm hàm này vào cuối file FirebaseService.js
export const uploadMeetingDatesToFirestore = async (meetingDatesObject) => {
  try {
    // Dùng setDoc với merge: true để ghi đè/thêm mới các ngày có họp 
    // vào đúng cấu trúc mà giao diện CatechistAttendanceManager đang dùng
    await setDoc(doc(firestore, 'settings', 'attendance_meetings'), meetingDatesObject, { merge: true });
    return { success: true, message: 'Đã cập nhật các ngày có Họp thành công!' };
  } catch (error) {
    console.error('Lỗi khi lưu ngày họp:', error);
    return { success: false, message: error.message };
  }
};

export const fetchCatechistAttendanceByName = async (fullName) => {
  try {
    console.log("🔍 Tên gốc đưa vào tìm kiếm:", fullName);
    const attendanceCollection = collection(firestore, 'catechist_attendance');
    const snapshot = await getDocs(attendanceCollection);
    const allRecords = snapshot.docs.map(doc => doc.data());

    // Hàm CHUẨN HÓA TIẾNG VIỆT Tuyệt Đối:
    // Đồng nhất Unicode -> Chữ thường -> Xóa khoảng trắng kép -> Cắt khoảng trắng 2 đầu
    const normalizeName = (name) => {
      if (!name) return '';
      return name.normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
    };

    const searchName = normalizeName(fullName);
    console.log("🎯 Tên sau khi chuẩn hóa:", searchName);

    const foundRecord = allRecords.find(record => {
      const dbName = normalizeName(record['Họ và tên']);
      return dbName === searchName;
    });

    if (foundRecord) {
      console.log("✅ TÌM THẤY! Dữ liệu:", foundRecord);
      return foundRecord.attendance || [];
    } else {
      console.warn("❌ KHÔNG KHỚP! Hãy kiểm tra log Tên chuẩn hóa bên trên xem có bị sai chính tả không.");
      return [];
    }
  } catch (error) {
    console.error('🔥 Lỗi FirebaseService:', error);
    return [];
  }
};

/**
 * 1. Lấy thông tin điểm thưởng từ Firestore (Hỗ trợ cả Thiếu nhi và Giáo lý viên)
 */
export const fetchStudentRewardsFirestore = async (userId, isCatechist = false) => {
  try {
    if (!userId) return { totalStars: 0, dailyToday: false, hasQuizToday: false, quizAttemptsToday: 0, adAttemptsToday: 0 };

    const todayStr = new Date().toISOString().split('T')[0];
    const collectionName = isCatechist ? 'staff' : 'students';

    const userRef = doc(firestore, collectionName, userId);
    const dailyDocRef = doc(firestore, `${collectionName}/${userId}/reward_transactions`, `${todayStr}_daily`);
    const quizDocRef = doc(firestore, `${collectionName}/${userId}/reward_transactions`, `${todayStr}_quiz`);
    const adDocRef = doc(firestore, `${collectionName}/${userId}/reward_transactions`, `${todayStr}_watch_ad`); // Thêm ref này

    const [userSnap, dailySnap, quizSnap, adSnap] = await Promise.all([
      getDoc(userRef),
      getDoc(dailyDocRef),
      getDoc(quizDocRef),
      getDoc(adDocRef) // Đọc song song
    ]);

    let totalStars = 0;
    if (userSnap.exists()) {
      const userData = userSnap.data();
      totalStars = userData.currentStars ?? ((userData.totalEarnedStars || 0) - (userData.totalRedeemedStars || 0));
    }

    const dailyToday = dailySnap.exists();
    const quizData = quizSnap.exists() ? quizSnap.data() : {};
    const quizAttemptsToday = quizData.attempts || 0;
    const adData = adSnap.exists() ? adSnap.data() : {};
    const adAttemptsToday = adData.attempts || 0;

    return {
      totalStars,
      dailyToday,
      hasQuizToday: quizAttemptsToday >= 3,
      quizAttemptsToday,
      adAttemptsToday
    };
  } catch (error) {
    console.error('Lỗi khi lấy điểm thưởng Firestore:', error);
    return { totalStars: 0, dailyToday: false, hasQuizToday: false, quizAttemptsToday: 0, adAttemptsToday: 0 };
  }
};

/**
 * 2. Điểm danh nhận 1 sao mỗi ngày (Hỗ trợ cả Thiếu nhi và Giáo lý viên)
 */
export const updateDailyRewardFirestore = async (userId, isCatechist = false) => {
  try {
    if (!userId || userId === 'undefined' || userId === 'GLV') {
      return { success: false, message: 'Chưa có mã ID người dùng' };
    }

    const todayStr = new Date().toISOString().split('T')[0];
    const collectionName = isCatechist ? 'staff' : 'students';
    const transDocId = `${todayStr}_daily`;

    const transRef = doc(firestore, `${collectionName}/${userId}/reward_transactions`, transDocId);
    const userRef = doc(firestore, collectionName, userId);

    return await runTransaction(firestore, async (transaction) => {
      const transSnap = await transaction.get(transRef);
      if (transSnap.exists()) {
        return { success: false, message: 'Bạn đã nhận thưởng hàng ngày hôm nay rồi.' };
      }

      // 1. Ghi lịch sử giao dịch nhận thưởng trong ngày
      transaction.set(transRef, {
        amount: 1,
        type: 'DAILY_CHECKIN',
        title: `Nhận sao ngày ${todayStr}`,
        createdAt: new Date().toISOString(),
        createdBy: isCatechist ? 'CATECHIST' : 'STUDENT',
        status: 'COMPLETED'
      });

      // 2. Tăng số sao tích lũy và số sao khả dụng
      transaction.set(userRef, {
        totalEarnedStars: increment(1),
        currentStars: increment(1)
      }, { merge: true });

      return { success: true };
    });

  } catch (error) {
    console.error('Lỗi nhận điểm thưởng hàng ngày:', error);
    return { success: false, message: 'Lỗi hệ thống: ' + error.message };
  }
};

/**
 * 3. Cập nhật điểm Đố vui Kinh Thánh vào Firestore (Hỗ trợ cả Thiếu nhi & Giáo lý viên)
 */
export const updateQuizScoreFirestore = async (userId, addedScore = 0, isCatechist = false) => {
  try {
    // 1. Kiểm tra an toàn ID người dùng
    if (!userId || userId === 'undefined' || userId === 'GLV') {
      return { success: false, message: 'Mã ID người dùng không hợp lệ.' };
    }

    // 2. Ép kiểu điểm số an toàn (Tránh NaN/undefined)
    const safeScore = Number.isInteger(addedScore) && addedScore > 0 ? addedScore : 0;
    const todayStr = new Date().toISOString().split('T')[0];
    const collectionName = isCatechist ? 'staff' : 'students';
    const transDocId = `${todayStr}_quiz`;

    const transRef = doc(firestore, `${collectionName}/${userId}/reward_transactions`, transDocId);
    const userRef = doc(firestore, collectionName, userId);

    return await runTransaction(firestore, async (transaction) => {
      // BƯỚC 1: ĐỌC DỮ LIỆU TRƯỚC (Must read before write)
      const transSnap = await transaction.get(transRef);

      let currentAttempts = 0;
      let currentAmount = 0;

      if (transSnap.exists()) {
        const data = transSnap.data();
        currentAttempts = Number(data.attempts) || 0;
        currentAmount = Number(data.amount) || 0;
      }

      if (currentAttempts >= 3) {
        return { 
          success: false, 
          isMaxAttempts: true, 
          message: 'Bạn đã đạt giới hạn 3 lần nhận thưởng hôm nay. Vẫn có thể tiếp tục chơi luyện tập!' 
        };
      }

      const newAttempts = currentAttempts + 1;
      const newAmount = currentAmount + safeScore;

      // BƯỚC 2: GHI DỮ LIỆU SAU (Không chứa bất kỳ giá trị undefined nào)
      transaction.set(transRef, {
        amount: Number(newAmount) || 0,
        attempts: Number(newAttempts) || 1,
        type: 'BIBLE_QUIZ',
        title: `Đố vui Kinh Thánh ngày ${todayStr}`,
        createdAt: new Date().toISOString(),
        createdBy: isCatechist ? 'CATECHIST' : 'STUDENT',
        status: 'COMPLETED'
      }, { merge: true });

      if (safeScore > 0) {
        transaction.set(userRef, {
          totalEarnedStars: increment(safeScore),
          currentStars: increment(safeScore)
        }, { merge: true });
      }

      return { success: true, added: safeScore, attempts: newAttempts };
    });

  } catch (error) {
    console.error('Lỗi lưu điểm đố vui:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 4. Lấy thông tin cơ bản Thiếu nhi từ Firestore (Dùng cho FunLearn.js)
 */
export const fetchStudentInfoFirestore = async (studentId) => {
  try {
    const studentSnap = await getDoc(doc(firestore, 'students', studentId));
    if (!studentSnap.exists()) {
      return { error: 'Mã ID không tồn tại trong hệ thống. Vui lòng kiểm tra lại!' };
    }
    const data = studentSnap.data();
    return {
      holyName: data.holyName || '',
      fullName: data.fullName || studentId
    };
  } catch (error) {
    console.error('Lỗi tra cứu thông tin học sinh:', error);
    return { error: 'Lỗi tra cứu thông tin: ' + error.message };
  }
};

/**
 * 5. Lấy toàn bộ danh sách điểm thưởng để làm báo cáo Thống kê (Dùng cho QuizStatistics.js)
 */
export const fetchAllRewardsFirestore = async () => {
  try {
    const studentsSnap = await getDocs(collection(firestore, 'students'));
    const result = {};

    for (const studentDoc of studentsSnap.docs) {
      const sId = studentDoc.id;
      const transSnap = await getDocs(collection(firestore, `students/${sId}/reward_transactions`));

      let totalStars = 0;
      let totalAttempts = 0;

      transSnap.docs.forEach(d => {
        const data = d.data();
        if (data.type === 'BIBLE_QUIZ') {
          totalStars += (data.amount || 0);
          totalAttempts += (data.attempts || 0);
        }
      });

      result[sId] = {
        totalStars,
        totalAttempts
      };
    }

    return result;
  } catch (error) {
    console.error('Lỗi khi lấy toàn bộ điểm thưởng Firestore:', error);
    return {};
  }
};

/**
 * Lấy danh sách Niên Khóa từ Firestore dành cho Phụ huynh
 */
export const fetchAcademicYearsList = async () => {
  try {
    const q = query(collection(firestore, 'academic_years'), orderBy('startDate', 'desc'));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({
      id: d.id,
      name: d.data().name || d.id,
      isCurrent: d.data().isCurrent || false
    }));
  } catch (err) {
    console.error('Lỗi khi tải danh sách niên khóa:', err);
    return [];
  }
};

/**
 * Lấy chi tiết thông tin Thiếu Nhi, Lớp học, Bảng điểm và Điểm danh theo Niên khóa từ Firestore
 */
export const fetchParentStudentDetail = async (studentId, yearId) => {
  try {
    if (!studentId) return { error: 'Chưa có mã ID thiếu nhi' };

    // 1. Hồ sơ gốc Thiếu Nhi từ /students/{studentId}
    const studentSnap = await getDoc(doc(firestore, 'students', studentId));
    if (!studentSnap.exists()) {
      return { error: 'Không tìm thấy hồ sơ thiếu nhi với mã ID này' };
    }
    const profile = { id: studentSnap.id, ...studentSnap.data() };

    // 2. Thông tin Phân Lớp & Bảng Điểm từ /academic_years/{yearId}/enrollments/{studentId}
    let enrollment = null;
    let className = 'Chưa phân lớp';

    if (yearId) {
      const enrSnap = await getDoc(doc(firestore, `academic_years/${yearId}/enrollments`, studentId));
      if (enrSnap.exists()) {
        enrollment = enrSnap.data();
        if (enrollment.classId) {
          const classSnap = await getDoc(doc(firestore, `academic_years/${yearId}/classes`, enrollment.classId));
          if (classSnap.exists()) {
            className = classSnap.data().name || enrollment.classId;
          } else {
            className = enrollment.classId;
          }
        }
      }
    }

    // 3. ⚡ ĐỌC ĐIỂM DANH TRỰC TIẾP TỪ 1 DOCUMENT: /academic_years/{yearId}/student_attendances/{studentId}
    let churchAttendance = {};
    let catechismAttendance = {};

    if (yearId) {
      const attSnap = await getDoc(doc(firestore, `academic_years/${yearId}/student_attendances`, studentId));
      if (attSnap.exists()) {
        const attData = attSnap.data();
        churchAttendance = attData.church || {};
        catechismAttendance = attData.catechism || {};
      }
    }

    return {
      profile,
      className,
      transcript: enrollment?.transcript || null,
      churchAttendance,
      catechismAttendance
    };

  } catch (err) {
    console.error('Lỗi khi tải chi tiết thông tin phụ huynh:', err);
    return { error: 'Lỗi kết nối hệ thống: ' + err.message };
  }
};

// src/FirebaseService.js - Bổ sung luồng REST API thuần cho trang Phụ Huynh

const FIRESTORE_REST_BASE = 'https://firestore.googleapis.com/v1/projects/project-bee-84b5e/databases/(default)/documents';

// Helper 1: Parser chuyển đổi kiểu dữ liệu Firestore REST API sang Object JS chuẩn
const parseFirestoreValue = (field) => {
  if (!field) return null;
  if ('stringValue' in field) return field.stringValue;
  if ('integerValue' in field) return parseInt(field.integerValue, 10);
  if ('doubleValue' in field) return parseFloat(field.doubleValue);
  if ('booleanValue' in field) return field.booleanValue;
  if ('nullValue' in field) return null;
  if ('timestampValue' in field) return field.timestampValue;
  if ('mapValue' in field) {
    const fields = field.mapValue?.fields || {};
    const result = {};
    for (const [key, val] of Object.entries(fields)) {
      result[key] = parseFirestoreValue(val);
    }
    return result;
  }
  if ('arrayValue' in field) {
    const values = field.arrayValue?.values || [];
    return values.map(parseFirestoreValue);
  }
  return null;
};

// Helper 2: Parser chuyển đổi toàn bộ Document REST API
const parseFirestoreDocument = (docJson) => {
  if (!docJson || !docJson.fields) return null;
  const result = {};
  for (const [key, val] of Object.entries(docJson.fields)) {
    result[key] = parseFirestoreValue(val);
  }
  return result;
};

/**
 * ⚡ REST API: Lấy danh sách Niên khóa bằng fetch() thuần (Zero Firebase SDK)
 */
export const fetchAcademicYearsListRest = async () => {
  try {
    const res = await fetch(`${FIRESTORE_REST_BASE}/academic_years`);
    if (!res.ok) return [];

    const data = await res.json();
    const documents = data.documents || [];

    const years = documents.map(doc => {
      const parsed = parseFirestoreDocument(doc) || {};
      const docId = doc.name.split('/').pop();
      return {
        id: docId,
        name: parsed.name || docId,
        isCurrent: Boolean(parsed.isCurrent),
        startDate: parsed.startDate || ''
      };
    });

    return years.sort((a, b) => b.startDate.localeCompare(a.startDate));
  } catch (err) {
    console.error('Lỗi REST fetchAcademicYearsList:', err);
    return [];
  }
};

/**
 * ⚡ REST API: Lấy chi tiết Hồ sơ, Lớp học, Bảng điểm & Điểm danh thiếu nhi
 * Gọi song song các REST Request (HTTP GET), phản hồi dưới 50ms, 0% kết nối ngầm
 */
export const fetchParentStudentDetailRest = async (studentId, yearId) => {
  try {
    if (!studentId) return { error: 'Chưa có mã ID thiếu nhi' };

    // 1. Lấy Hồ sơ gốc Thiếu Nhi
    const studentRes = await fetch(`${FIRESTORE_REST_BASE}/students/${studentId}`);
    if (!studentRes.ok) {
      if (studentRes.status === 404) {
        return { error: 'Không tìm thấy hồ sơ thiếu nhi với mã ID này' };
      }
      return { error: 'Lỗi kết nối máy chủ' };
    }
    const studentDocJson = await studentRes.json();
    const profile = { id: studentId, ...(parseFirestoreDocument(studentDocJson) || {}) };

    // 2. Lấy Phân Lớp, Điểm Danh & Thông Tin Lớp
    let enrollment = null;
    let className = 'Chưa phân lớp';
    let churchAttendance = {};
    let catechismAttendance = {};

    if (yearId) {
      const [enrRes, attRes] = await Promise.all([
        fetch(`${FIRESTORE_REST_BASE}/academic_years/${yearId}/enrollments/${studentId}`),
        fetch(`${FIRESTORE_REST_BASE}/academic_years/${yearId}/student_attendances/${studentId}`)
      ]);

      if (enrRes.ok) {
        const enrJson = await enrRes.json();
        enrollment = parseFirestoreDocument(enrJson);

        if (enrollment?.classId) {
          const classRes = await fetch(`${FIRESTORE_REST_BASE}/academic_years/${yearId}/classes/${enrollment.classId}`);
          if (classRes.ok) {
            const classJson = await classRes.json();
            const classParsed = parseFirestoreDocument(classJson);
            className = classParsed?.name || enrollment.classId;
          } else {
            className = enrollment.classId;
          }
        }
      }

      if (attRes.ok) {
        const attJson = await attRes.json();
        const attParsed = parseFirestoreDocument(attJson) || {};
        churchAttendance = attParsed.church || {};
        catechismAttendance = attParsed.catechism || {};
      }
    }

    return {
      profile,
      className,
      transcript: enrollment?.transcript || null,
      churchAttendance,
      catechismAttendance
    };

  } catch (err) {
    console.error('Lỗi REST fetchParentStudentDetail:', err);
    return { error: 'Lỗi kết nối hệ thống: ' + err.message };
  }
};

// src/FirebaseService.js - Bổ sung các hàm đọc SDK Firestore độc lập cho từng phần

/**
 * 1. Đọc nhanh Hồ sơ cá nhân Thiếu nhi (Trả về ngay để render Profile Card)
 */
export const fetchStudentProfileSDK = async (studentId) => {
  try {
    const snap = await getDoc(doc(firestore, 'students', studentId));
    if (!snap.exists()) return { error: 'Không tìm thấy hồ sơ thiếu nhi với mã ID này' };
    return { success: true, data: { id: snap.id, ...snap.data() } };
  } catch (err) {
    return { error: 'Lỗi nạp hồ sơ: ' + err.message };
  }
};

/**
 * 2. Đọc Phân lớp & Bảng điểm theo Niên khóa
 */
export const fetchStudentEnrollmentSDK = async (studentId, yearId) => {
  try {
    if (!yearId) return { className: 'Chưa phân lớp', transcript: null };

    const enrSnap = await getDoc(doc(firestore, `academic_years/${yearId}/enrollments`, studentId));
    if (!enrSnap.exists()) return { className: 'Chưa phân lớp', transcript: null };

    const enrData = enrSnap.data();
    let className = enrData.classId || 'Chưa phân lớp';

    if (enrData.classId) {
      const classSnap = await getDoc(doc(firestore, `academic_years/${yearId}/classes`, enrData.classId));
      if (classSnap.exists()) {
        className = classSnap.data().name || enrData.classId;
      }
    }

    return { className, transcript: enrData.transcript || null };
  } catch (err) {
    return { className: 'Chưa phân lớp', transcript: null };
  }
};

/**
 * 3. Đọc Nhật ký Điểm danh theo Niên khóa từ /student_attendances/{studentId}
 */
export const fetchStudentAttendanceSDK = async (studentId, yearId) => {
  try {
    if (!yearId) return { churchAttendance: {}, catechismAttendance: {} };

    const attSnap = await getDoc(doc(firestore, `academic_years/${yearId}/student_attendances`, studentId));
    if (!attSnap.exists()) return { churchAttendance: {}, catechismAttendance: {} };

    const data = attSnap.data();
    return {
      churchAttendance: data.church || {},
      catechismAttendance: data.catechism || {}
    };
  } catch (err) {
    return { churchAttendance: {}, catechismAttendance: {} };
  }
};

// src/FirebaseService.js - Bổ sung Realtime Transcript Locks & Batch Update Enrollments

/**
 * 1. Lắng nghe trạng thái khóa Bảng Điểm Thời Gian Thực của 1 Lớp
 */
export const subscribeTranscriptLocks = (yearId, classId, callback) => {
  if (!yearId || !classId) return () => { };
  const lockDocRef = doc(firestore, `academic_years/${yearId}/transcript_locks`, classId);
  return onSnapshot(lockDocRef, (snap) => {
    if (snap.exists()) {
      callback(snap.data());
    } else {
      callback({ isLocked: false, semester1: {}, semester2: {} });
    }
  }, (err) => {
    console.error('Lỗi lắng nghe khóa bảng điểm:', err);
  });
};

/**
 * 2. Lắng nghe trạng thái khóa Bảng Điểm Thời Gian Thực của Tất Cả Các Lớp (Dành cho Admin)
 */
export const subscribeAllTranscriptLocks = (yearId, callback) => {
  if (!yearId) return () => { };
  const locksCollRef = collection(firestore, `academic_years/${yearId}/transcript_locks`);
  return onSnapshot(locksCollRef, (snap) => {
    const map = {};
    snap.docs.forEach(d => {
      map[d.id] = d.data();
    });
    callback(map);
  }, (err) => {
    console.error('Lỗi lắng nghe toàn bộ khóa bảng điểm:', err);
  });
};

/**
 * 3. Cập nhật / Bật Tắt Khóa Bảng Điểm (Tổng lớp hoặc từng Cột điểm)
 */
export const updateTranscriptLockRealtime = async (yearId, classId, updates) => {
  try {
    if (!yearId || !classId) return { success: false };
    const lockDocRef = doc(firestore, `academic_years/${yearId}/transcript_locks`, classId);
    await setDoc(lockDocRef, updates, { merge: true });
    return { success: true };
  } catch (err) {
    console.error('Lỗi cập nhật khóa bảng điểm:', err);
    return { success: false, message: err.message };
  }
};

/**
 * 4. Cập nhật Bảng Điểm Lô (Write Batch) vào từng /academic_years/{yearId}/enrollments/{studentId}
 */
export const updateTranscriptBatch = async (yearId, classId, transcriptMap) => {
  try {
    if (!yearId || !classId || !transcriptMap) return { success: false, message: 'Dữ liệu không hợp lệ' };

    const studentIds = Object.keys(transcriptMap);
    const CHUNK_SIZE = 400; // An toàn dưới ngưỡng 500 operations/batch

    for (let i = 0; i < studentIds.length; i += CHUNK_SIZE) {
      const chunk = studentIds.slice(i, i + CHUNK_SIZE);
      const batch = writeBatch(firestore);

      chunk.forEach((sId) => {
        const enrRef = doc(firestore, `academic_years/${yearId}/enrollments`, sId);
        batch.set(enrRef, {
          studentId: sId,
          classId: classId,
          transcript: transcriptMap[sId] || {}
        }, { merge: true });
      });

      await batch.commit();
    }

    return { success: true };
  } catch (err) {
    console.error('Lỗi khi lưu bảng điểm theo lô:', err);
    return { success: false, message: err.message };
  }
};

// src/FirebaseService.js - Bổ sung hàm Reset Mật Khẩu Giáo Lý Viên

export const resetCatechistPassword = async (uid, newPassword) => {
  try {
    if (!uid || !newPassword) {
      return { success: false, message: 'Dữ liệu không hợp lệ.' };
    }

    // 1. Gọi Cloud Function để đổi mật khẩu trên Firebase Authentication
    const resetFunc = httpsCallable(functions, 'resetUserPassword');
    const result = await resetFunc({ uid, newPassword });

    if (result.data?.success) {
      // 2. Đặt lại số lần đổi mật khẩu về 0 và cập nhật thời gian đổi
      const staffDoc = doc(firestore, `staff/${uid}`);
      await updateDoc(staffDoc, {
        passwordChangeCount: 0,
        lastPasswordChange: Timestamp.now()
      });

      cachedCatechists = null;
      return { success: true };
    } else {
      return {
        success: false,
        message: result.data?.message || 'Lỗi khi cập nhật mật khẩu trên Auth.'
      };
    }
  } catch (error) {
    console.error('Lỗi resetCatechistPassword:', error);
    return { success: false, message: error.message || 'Lỗi kết nối máy chủ.' };
  }
};

// ====================================================================
// BỘ HÀM QUẢN LÝ ĐIỂM DANH & ĐƠN XIN PHÉP GIÁO LÝ VIÊN THEO NIÊN KHÓA
// ====================================================================

/**
 * 1. Lấy dữ liệu điểm danh Giáo lý viên của một ngày theo Niên khóa
 */
export const fetchBlockAttendance = async (yearId, dateStr) => {
  try {
    if (!yearId || !dateStr) return { date: dateStr, hasMeeting: false, records: {} };
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, dateStr);
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      return snap.data();
    }
    return { date: dateStr, hasMeeting: false, records: {} };
  } catch (error) {
    console.error('Lỗi khi tải điểm danh GLV:', error);
    return { date: dateStr, hasMeeting: false, records: {} };
  }
};

/**
 * 2. Lưu / Cập nhật điểm danh Giáo lý viên của một ngày theo Niên khóa
 */
export const saveBlockAttendance = async (yearId, dateStr, attendanceData) => {
  try {
    if (!yearId || !dateStr) return { success: false, message: 'Thiếu niên khóa hoặc ngày điểm danh.' };
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, dateStr);
    await setDoc(docRef, {
      date: dateStr,
      hasMeeting: Boolean(attendanceData.hasMeeting),
      records: attendanceData.records || {},
      updatedAt: Timestamp.now()
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi lưu điểm danh GLV:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 3. Giáo lý viên gửi đơn xin nghỉ
 */
export const createLeaveRequest = async (yearId, requestData) => {
  try {
    if (!yearId) return { success: false, message: 'Thiếu thông tin niên khóa.' };
    const colRef = collection(firestore, `academic_years/${yearId}/catechist_leave_requests`);
    const docRef = await addDoc(colRef, {
      catechistUid: requestData.catechistUid || '',
      holyName: requestData.holyName || '',
      fullName: requestData.fullName || '',
      blockGroup: requestData.blockGroup || '',
      className: requestData.className || '',
      requestDate: requestData.requestDate || '',
      reason: requestData.reason || '',
      absentActivities: requestData.absentActivities || [], // Ví dụ: ['mass', 'teaching', 'meeting']
      status: 'pending',
      reviewedBy: '',
      reviewerNote: '',
      createdAt: Timestamp.now()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Lỗi khi tạo đơn xin nghỉ:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 4. Tải danh sách đơn xin nghỉ theo Khối (Dành cho Trưởng Khối & Admin)
 */
// src/FirebaseService.js - Cập nhật hàm nạp đơn xin nghỉ mềm dẻo

export const fetchLeaveRequestsByBlock = async (yearId, blockName) => {
  try {
    if (!yearId) return [];
    const colRef = collection(firestore, `academic_years/${yearId}/catechist_leave_requests`);

    // Tải toàn bộ đơn xin nghỉ trong niên khóa, xếp mới nhất lên đầu
    const q = query(colRef, orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    const allRequests = snap.docs.map(d => ({ id: d.id, ...d.data() }));

    // Admin hoặc xem tất cả
    if (!blockName || blockName === 'all' || blockName === 'Admin') {
      return allRequests;
    }

    // Hàm tách từ khóa chuẩn hóa (bỏ chữ "khối", "ngành", bỏ dấu tiếng Việt, ký tự đặc biệt)
    const extractTokens = (str) => {
      if (!str) return [];
      return str
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\b(khoi|nganh)\b/g, '') // Loại bỏ tiền tố "khối", "ngành"
        .replace(/[^a-z0-9\s]/g, ' ')
        .trim()
        .split(/\s+/)
        .filter(w => w.length >= 2); // Chỉ lấy các từ từ 2 ký tự trở lên
    };

    const targetTokens = extractTokens(blockName);
    if (targetTokens.length === 0) return allRequests;

    return allRequests.filter(req => {
      const reqBlockTokens = extractTokens(req.blockGroup);
      const reqClassTokens = extractTokens(req.className);
      const reqAllTokens = [...reqBlockTokens, ...reqClassTokens];

      // Chỉ cần có ÍT NHẤT 1 TỪ KHÓA khớp (VD: "thiếu" hoặc "thêm" hoặc "sức") là duyệt thấy đơn
      return targetTokens.some(tToken => reqAllTokens.includes(tToken));
    });
  } catch (error) {
    console.error('Lỗi khi tải đơn xin nghỉ theo khối:', error);
    return [];
  }
};

/**
 * 5. Tải danh sách đơn xin nghỉ của cá nhân Giáo lý viên
 */
export const fetchLeaveRequestsByCatechist = async (yearId, catechistUid) => {
  try {
    if (!yearId || !catechistUid) return [];
    const colRef = collection(firestore, `academic_years/${yearId}/catechist_leave_requests`);
    const q = query(colRef, where('catechistUid', '==', catechistUid), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.error('Lỗi khi tải đơn xin nghỉ cá nhân:', error);
    return [];
  }
};

/**
 * 1. Lắng nghe Đơn xin nghỉ theo Khối Thời Gian Thực (Dành cho Trưởng Khối & Admin)
 */
export const subscribeLeaveRequestsByBlock = (yearId, blockName, callback) => {
  if (!yearId) return () => { };
  const colRef = collection(firestore, `academic_years/${yearId}/catechist_leave_requests`);

  return onSnapshot(colRef, (snap) => {
    const allRequests = snap.docs.map(d => ({ id: d.id, ...d.data() }));

    // Sắp xếp đơn mới nhất lên đầu
    allRequests.sort((a, b) => {
      const timeA = a.createdAt?.seconds || 0;
      const timeB = b.createdAt?.seconds || 0;
      return timeB - timeA;
    });

    if (!blockName || blockName === 'all' || blockName === 'Admin') {
      callback(allRequests);
      return;
    }

    // Tách từ khóa chuẩn hóa
    const extractTokens = (str) => {
      if (!str) return [];
      return str
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\b(khoi|nganh)\b/g, '')
        .replace(/[^a-z0-9\s]/g, ' ')
        .trim()
        .split(/\s+/)
        .filter(w => w.length >= 2);
    };

    const targetTokens = extractTokens(blockName);
    if (targetTokens.length === 0) {
      callback(allRequests);
      return;
    }

    const filtered = allRequests.filter(req => {
      const reqBlockTokens = extractTokens(req.blockGroup);
      const reqClassTokens = extractTokens(req.className);
      const reqAllTokens = [...reqBlockTokens, ...reqClassTokens];
      return targetTokens.some(tToken => reqAllTokens.includes(tToken));
    });

    callback(filtered);
  }, (error) => {
    console.error('Lỗi realtime đơn xin nghỉ theo khối:', error);
  });
};

/**
 * 2. Lắng nghe Đơn xin nghỉ Cá Nhân Thời Gian Thực (Dành cho Giáo Lý Viên)
 */
export const subscribeLeaveRequestsByCatechist = (yearId, catechistUid, callback) => {
  if (!yearId || !catechistUid) return () => { };
  const colRef = collection(firestore, `academic_years/${yearId}/catechist_leave_requests`);
  const q = query(colRef, where('catechistUid', '==', catechistUid));

  return onSnapshot(q, (snap) => {
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    list.sort((a, b) => {
      const timeA = a.createdAt?.seconds || 0;
      const timeB = b.createdAt?.seconds || 0;
      return timeB - timeA;
    });
    callback(list);
  }, (error) => {
    console.error('Lỗi realtime đơn xin nghỉ cá nhân:', error);
  });
};

/**
 * 6. Trưởng khối / Admin duyệt hoặc từ chối đơn xin nghỉ
 */
export const updateLeaveRequestStatus = async (yearId, requestId, status, reviewerUid, reviewerNote = '') => {
  try {
    if (!yearId || !requestId) return { success: false, message: 'Dữ liệu không hợp lệ.' };
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_leave_requests`, requestId);
    await updateDoc(docRef, {
      status: status, // 'approved' | 'rejected'
      reviewedBy: reviewerUid || '',
      reviewerNote: reviewerNote,
      reviewedAt: Timestamp.now()
    });
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi cập nhật trạng thái đơn xin nghỉ:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 1. Ghi nhận điểm danh Giáo lý viên bằng mã QR (Lưu theo UID)
 */
export const recordCatechistScan = async (yearId, targetUid, activityType, timeStr, scannerUid) => {
  try {
    if (!yearId || !targetUid || !activityType) {
      return { success: false, message: 'Dữ liệu điểm danh không hợp lệ.' };
    }

    const todayStr = new Date().toISOString().split('T')[0];
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, targetUid);

    await setDoc(docRef, {
      [todayStr]: {
        [activityType]: `Có lúc ${timeStr}`, // mass | teaching | meeting
        scannedBy: scannerUid || 'SYSTEM',
        updatedAt: Timestamp.now()
      }
    }, { merge: true });

    return { success: true };
  } catch (error) {
    console.error('Lỗi khi ghi nhận quét QR GLV:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 2. Cập nhật Đơn xin nghỉ chưa duyệt (Pending)
 */
export const updateLeaveRequest = async (yearId, requestId, updates) => {
  try {
    if (!yearId || !requestId) return { success: false, message: 'Dữ liệu không hợp lệ.' };
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_leave_requests`, requestId);

    await updateDoc(docRef, {
      ...updates,
      updatedAt: Timestamp.now()
    });
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi cập nhật đơn xin nghỉ:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 3. Đọc lịch sử điểm danh cá nhân theo UID từ /catechist_attendances/{UID}
 */
export const fetchCatechistAttendanceByUid = async (yearId, uid) => {
  try {
    if (!yearId || !uid) return {};
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, uid);
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      return snap.data();
    }
    return {};
  } catch (error) {
    console.error('Lỗi khi tải lịch sử điểm danh GLV:', error);
    return {};
  }
};

//  Bổ sung hàm điểm danh đồng thời cả 3 hoạt động

export const recordCatechistScanAll = async (yearId, targetUid, timeStr, scannerUid) => {
  try {
    if (!yearId || !targetUid) {
      return { success: false, message: 'Dữ liệu điểm danh không hợp lệ.' };
    }

    const todayStr = new Date().toISOString().split('T')[0];
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, targetUid);
    const timeValue = `Có lúc ${timeStr}`;

    // 1. Kiểm tra ngày hôm nay có lịch họp hay không
    const meetingSettingsRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_meetings');
    const meetingSnap = await getDoc(meetingSettingsRef);
    const hasMeetingToday = meetingSnap.exists() ? Boolean(meetingSnap.data()?.[todayStr]) : false;

    // 2. Thiết lập dữ liệu lưu
    const recordPayload = {
      mass: timeValue,
      teaching: timeValue,
      scannedBy: scannerUid || 'SYSTEM',
      updatedAt: Timestamp.now()
    };

    // Chỉ ghi nhận buổi Họp nếu hôm nay thực sự có lịch họp
    if (hasMeetingToday) {
      recordPayload.meeting = timeValue;
    }

    await setDoc(docRef, {
      [todayStr]: recordPayload
    }, { merge: true });

    return { success: true, timeStr, hasMeetingToday };
  } catch (error) {
    console.error('Lỗi khi ghi nhận quét QR GLV:', error);
    return { success: false, message: error.message };
  }
};

/**
 * Lắng nghe Lịch sử điểm danh Cá nhân Giáo lý viên Thời gian thực (Realtime)
 */
export const subscribeCatechistAttendanceByUid = (yearId, uid, callback) => {
  if (!yearId || !uid) return () => { };
  const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, uid);
  return onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback(snap.data());
    } else {
      callback({});
    }
  }, (err) => {
    console.error('Lỗi lắng nghe điểm danh GLV realtime:', err);
  });
};

/**
 * Lưu/Cập nhật điểm danh 1 Giáo lý viên trực tiếp theo Thời gian thực
 */
export const saveSingleCatechistAttendance = async (yearId, uid, dateStr, recordData) => {
  try {
    if (!yearId || !uid || !dateStr) return { success: false };
    const docRef = doc(firestore, `academic_years/${yearId}/catechist_attendances`, uid);
    await setDoc(docRef, {
      [dateStr]: {
        ...recordData,
        updatedAt: Timestamp.now()
      }
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi lưu điểm danh GLV realtime:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 1. Lưu Lịch Sử Ván Game Ma Sói vào Firestore khi kết thúc ván
 */
export const saveWerewolfGameHistoryFirestore = async (historyData) => {
  try {
    if (!historyData || !historyData.roomId) return { success: false };
    const historyCol = collection(firestore, 'werewolf_game_history');
    const docRef = await addDoc(historyCol, {
      ...historyData,
      createdAt: Timestamp.now()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Lỗi khi lưu lịch sử game Ma Sói vào Firestore:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 2. Tải Lịch Sử Ván Game Ma Sói theo Mã Phòng từ Firestore
 */
export const fetchWerewolfGameHistoryFirestore = async (roomId) => {
  try {
    if (!roomId) return [];
    const historyCol = collection(firestore, 'werewolf_game_history');
    const q = query(historyCol, where('roomId', '==', roomId), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Lỗi khi tải lịch sử game Ma Sói từ Firestore:', error);
    return [];
  }
};

/**
 * 6. Cộng sao khi xem quảng cáo (Hỗ trợ giới hạn số lượt/ngày và Atomic Transaction)
 * @param {string} userId - ID của Thiếu nhi hoặc UID của Giáo lý viên
 * @param {number} starsReward - Số sao thưởng cho mỗi lần xem (Mặc định: 2)
 * @param {boolean} isCatechist - Phân biệt GLV (staff) hay Thiếu nhi (students)
 * @param {number} maxDailyAds - Số lượt xem tối đa được nhận thưởng trong ngày (Mặc định: 3)
 */
export const addStarsForAdFirestore = async (
  userId,
  starsReward = 2,
  isCatechist = false,
  maxDailyAds = 3
) => {
  try {
    // 1. Kiểm tra mã người dùng hợp lệ
    if (!userId || userId === 'undefined' || userId === 'GLV') {
      return { success: false, message: 'Mã ID người dùng không hợp lệ.' };
    }

    const safeStars = Number.isInteger(starsReward) && starsReward > 0 ? starsReward : 2;
    const todayStr = new Date().toISOString().split('T')[0];
    const collectionName = isCatechist ? 'staff' : 'students';
    const transDocId = `${todayStr}_watch_ad`;

    const transRef = doc(firestore, `${collectionName}/${userId}/reward_transactions`, transDocId);
    const userRef = doc(firestore, collectionName, userId);

    return await runTransaction(firestore, async (transaction) => {
      // BƯỚC 1: Đọc dữ liệu giao dịch trong ngày
      const transSnap = await transaction.get(transRef);

      let currentAttempts = 0;
      let currentAmount = 0;

      if (transSnap.exists()) {
        const data = transSnap.data();
        currentAttempts = Number(data.attempts) || 0;
        currentAmount = Number(data.amount) || 0;
      }

      // Giới hạn lượt xem nhận thưởng trong ngày
      if (currentAttempts >= maxDailyAds) {
        return {
          success: false,
          isMaxAttempts: true,
          message: `Bạn đã đạt giới hạn nhận thưởng (${maxDailyAds} lần/ngày) khi xem video hôm nay.`
        };
      }

      const newAttempts = currentAttempts + 1;
      const newTotalAmount = currentAmount + safeStars;

      // BƯỚC 2: Cập nhật bản ghi Sổ cái giao dịch
      transaction.set(transRef, {
        amount: newTotalAmount,
        attempts: newAttempts,
        lastReward: safeStars,
        type: 'WATCH_AD',
        title: `Xem video tiếp sức ngày ${todayStr}`,
        createdAt: new Date().toISOString(),
        createdBy: isCatechist ? 'CATECHIST' : 'STUDENT',
        status: 'COMPLETED'
      }, { merge: true });

      // BƯỚC 3: Tăng điểm tổng và điểm khả dụng trên Profile gốc
      transaction.set(userRef, {
        totalEarnedStars: increment(safeStars),
        currentStars: increment(safeStars)
      }, { merge: true });

      return {
        success: true,
        added: safeStars,
        attempts: newAttempts,
        remainingAttempts: maxDailyAds - newAttempts
      };
    });

  } catch (error) {
    console.error('Lỗi cộng sao khi xem video quảng cáo:', error);
    return { success: false, message: 'Lỗi hệ thống: ' + error.message };
  }
};

/**
 * Cộng sao trực tiếp cho Thiếu Nhi / GLV (Không lưu số lần nhận lên Firestore)
 */
export const addRewardStarsOnly = async (userId, stars = 2, isCatechist = false) => {
  try {
    if (!userId || userId === 'undefined' || userId === 'GLV') {
      return { success: false, message: 'Mã ID người dùng không hợp lệ.' };
    }

    const collectionName = isCatechist ? 'staff' : 'students';
    const userRef = doc(firestore, collectionName, userId);

    // Chỉ tăng số sao khả dụng và tổng sao trên Profile gốc
    await setDoc(userRef, {
      totalEarnedStars: increment(stars),
      currentStars: increment(stars)
    }, { merge: true });

    return { success: true };
  } catch (error) {
    console.error('Lỗi khi cộng sao:', error);
    return { success: false, message: error.message };
  }
};

/**
 * Lắng nghe Hồ sơ cá nhân của Giáo lý viên theo Thời gian thực (Realtime)
 */
export const subscribeCatechistProfile = (uid, callback) => {
  if (!uid) return () => {};
  const docRef = doc(firestore, `staff/${uid}`);
  return onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback({ success: true, data: snap.data() });
    } else {
      callback({ success: false, message: 'Không tìm thấy thông tin giáo lý viên' });
    }
  }, (err) => {
    console.error('Lỗi lắng nghe hồ sơ GLV realtime:', err);
  });
};

// ====================================================================
// 💰 BỘ HÀM QUẢN LÝ HỌC PHÍ THIẾU NHI THEO NIÊN KHÓA (REALTIME)
// ====================================================================

/**
 * 1. Lắng nghe Cấu hình Mức Học Phí Niên Khóa (Realtime)
 */
export const subscribeTuitionSettings = (yearId, callback) => {
  if (!yearId) return () => {};
  const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'tuition_settings');
  return onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback(snap.data());
    } else {
      // Mặc định 100.000 VNĐ nếu chưa cài đặt
      callback({ feePerStudent: 100000 });
    }
  }, (err) => {
    console.error('Lỗi lắng nghe cấu hình học phí:', err);
    callback({ feePerStudent: 100000 });
  });
};

/**
 * 2. Cập nhật Mức Học Phí Niên Khóa
 */
export const updateTuitionSettings = async (yearId, feePerStudent, updatedByName = '') => {
  try {
    if (!yearId) return { success: false, message: 'Thiếu mã niên khóa' };
    const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'tuition_settings');
    await setDoc(docRef, {
      feePerStudent: Number(feePerStudent) || 100000,
      updatedAt: Timestamp.now(),
      updatedBy: updatedByName
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Lỗi cập nhật mức học phí:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 3. Lắng nghe Dữ liệu Học Phí của 1 Lớp cụ thể (Dành cho GLV trong ClassStudents)
 */
export const subscribeTuitionFeesByClass = (yearId, classId, callback) => {
  if (!yearId || !classId) return () => {};
  const q = query(
    collection(firestore, `academic_years/${yearId}/tuition_fees`),
    where('classId', '==', classId)
  );
  return onSnapshot(q, (snap) => {
    const map = {};
    snap.docs.forEach((d) => {
      map[d.id] = d.data();
    });
    callback(map);
  }, (err) => {
    console.error('Lỗi lắng nghe học phí lớp:', err);
  });
};

/**
 * 4. Lắng nghe Dữ liệu Học Phí Toàn Niên Khóa (Dành cho Admin & BHC)
 */
export const subscribeAllTuitionFees = (yearId, callback) => {
  if (!yearId) return () => {};
  const colRef = collection(firestore, `academic_years/${yearId}/tuition_fees`);
  return onSnapshot(colRef, (snap) => {
    const map = {};
    snap.docs.forEach((d) => {
      map[d.id] = d.data();
    });
    callback(map);
  }, (err) => {
    console.error('Lỗi lắng nghe toàn bộ học phí:', err);
  });
};

/**
 * 5. Giáo lý viên ghi nhận ĐÃ THU TIỀN của một thiếu nhi
 */
export const recordStudentTuitionCollected = async (yearId, studentId, classId, catechistName, catechistUid, dateStr = '', notes = '') => {
  try {
    if (!yearId || !studentId) return { success: false, message: 'Thiếu thông tin' };
    const docRef = doc(firestore, `academic_years/${yearId}/tuition_fees`, studentId);

    const todayStr = dateStr || new Date().toLocaleDateString('sv-SE');
    await setDoc(docRef, {
      studentId,
      classId,
      status: 'collected', // 'collected': GLV đã thu | 'confirmed': BHC đã nhận tiền
      collectedBy: catechistName || 'Giáo lý viên',
      collectedByUid: catechistUid || '',
      collectedDate: todayStr,
      collectedAt: Timestamp.now(),
      notes: notes || '',
    }, { merge: true });

    return { success: true };
  } catch (error) {
    console.error('Lỗi khi thu tiền học phí:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 6. Giáo lý viên HỦY THU (Chỉ được phép hủy khi Ban Hành Chánh chưa xác nhận)
 */
export const cancelStudentTuition = async (yearId, studentId) => {
  try {
    if (!yearId || !studentId) return { success: false, message: 'Thiếu thông tin' };
    const docRef = doc(firestore, `academic_years/${yearId}/tuition_fees`, studentId);
    
    // Kiểm tra trạng thái hiện tại
    const snap = await getDoc(docRef);
    if (snap.exists() && snap.data().status === 'confirmed') {
      return { success: false, message: 'Ban Hành Chánh đã xác nhận nhận tiền, không thể tự hủy!' };
    }

    await deleteDoc(docRef);
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi hủy thu học phí:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 7. Ban Hành Chánh XÁC NHẬN đã nhận tiền từ GLV (Hỗ trợ xác nhận 1 em hoặc theo lô)
 */
export const confirmTuitionBatch = async (yearId, studentIds = [], confirmedByName = '', confirmedByUid = '') => {
  try {
    if (!yearId || studentIds.length === 0) return { success: false, message: 'Không có học sinh nào' };

    const CHUNK_SIZE = 400;
    for (let i = 0; i < studentIds.length; i += CHUNK_SIZE) {
      const chunk = studentIds.slice(i, i + CHUNK_SIZE);
      const batch = writeBatch(firestore);

      chunk.forEach((sId) => {
        const docRef = doc(firestore, `academic_years/${yearId}/tuition_fees`, sId);
        batch.set(docRef, {
          status: 'confirmed',
          confirmedBy: confirmedByName || 'Ban Hành Chánh',
          confirmedByUid: confirmedByUid || '',
          confirmedAt: Timestamp.now()
        }, { merge: true });
      });

      await batch.commit();
    }

    return { success: true };
  } catch (error) {
    console.error('Lỗi khi BHC xác nhận học phí:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 8. Ban Hành Chánh HOÀN TÁC xác nhận (Chuyển về trạng thái GLV đã thu)
 */
export const revertTuitionConfirmationBatch = async (yearId, studentIds = []) => {
  try {
    if (!yearId || studentIds.length === 0) return { success: false };

    const batch = writeBatch(firestore);
    studentIds.forEach((sId) => {
      const docRef = doc(firestore, `academic_years/${yearId}/tuition_fees`, sId);
      batch.update(docRef, {
        status: 'collected',
        confirmedBy: '',
        confirmedByUid: '',
        confirmedAt: null
      });
    });

    await batch.commit();
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi hoàn tác xác nhận học phí:', error);
    return { success: false, message: error.message };
  }
};

// ====================================================================
// 🍜 QUẢN LÝ THỰC ĐƠN CÁ NHÂN HÓA (ĂN GÌ HÔM NAY)
// ====================================================================

/**
 * 1. Tải danh sách món ăn tùy chỉnh của người dùng từ Firestore
 * Đường dẫn: custom_foods/{creatorRole}/users/{userId}
 */
export const fetchUserCustomFoods = async (creatorRole, userId) => {
  try {
    if (!creatorRole || !userId) return [];
    const docRef = doc(firestore, `custom_foods/${creatorRole}/users`, String(userId));
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      const data = snap.data();
      return Array.isArray(data.foods) ? data.foods : [];
    }
    return [];
  } catch (error) {
    console.error('Lỗi khi tải thực đơn cá nhân từ Firestore:', error);
    return [];
  }
};

/**
 * 2. Lưu / Cập nhật toàn bộ mảng món ăn tùy chỉnh của người dùng
 */
export const saveUserCustomFoods = async (creatorRole, userId, payload) => {
  try {
    if (!creatorRole || !userId) return { success: false, message: 'Thiếu thông tin định danh.' };
    const docRef = doc(firestore, `custom_foods/${creatorRole}/users`, String(userId));
    await setDoc(docRef, {
      userID: String(userId),
      creatorRole: creatorRole,
      creatorName: payload.creatorName || '',
      foods: payload.foods || [],
      updatedAt: Timestamp.now()
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Lỗi khi lưu thực đơn cá nhân lên Firestore:', error);
    return { success: false, message: error.message };
  }
};

/**
 * Cập nhật quyền quét/điểm danh Giáo Lý Viên cho 1 GLV
 */
export const updateCatechistAttendanceAccess = async (uid, access) => {
  try {
    const staffDoc = doc(firestore, `staff/${uid}`);
    await updateDoc(staffDoc, { catechistAttendanceAccess: Boolean(access) });
    cachedCatechists = null;
    return { success: true };
  } catch (error) {
    console.error('Error updating catechist attendance access:', error);
    throw error;
  }
};

// ====================================================================
// 🔒 QUẢN LÝ KHÓA / MỞ NGÀY ĐIỂM DANH (REALTIME)
// ====================================================================

/**
 * Lắng nghe trạng thái khóa ngày điểm danh theo Niên khóa (Realtime)
 */
export const subscribeAttendanceDateLocks = (yearId, callback) => {
  if (!yearId) return () => {};
  const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_locks');
  return onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback(snap.data() || {});
    } else {
      callback({});
    }
  }, (err) => {
    console.error('Lỗi lắng nghe khóa ngày điểm danh:', err);
    callback({});
  });
};

/**
 * Cập nhật trạng thái khóa/mở 1 ngày điểm danh
 */
export const setAttendanceDateLock = async (yearId, dateStr, isLocked) => {
  try {
    if (!yearId || !dateStr) return false;
    const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_locks');
    await setDoc(docRef, {
      [dateStr]: Boolean(isLocked)
    }, { merge: true });

    // Đồng bộ thêm vào settings/attendance_locks toàn cục (nếu cần tương thích ngược)
    await setDoc(doc(firestore, 'settings', 'attendance_locks'), {
      [dateStr]: Boolean(isLocked)
    }, { merge: true });

    return true;
  } catch (error) {
    console.error('Lỗi cập nhật khóa ngày:', error);
    return false;
  }
};

/**
 * Cập nhật trạng thái khóa/mở nhiều ngày cùng lúc
 */
export const batchSetAttendanceDateLocks = async (yearId, locksObject) => {
  try {
    if (!yearId || !locksObject) return false;
    const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_locks');
    await setDoc(docRef, locksObject, { merge: true });
    return true;
  } catch (error) {
    console.error('Lỗi cập nhật lô khóa ngày:', error);
    return false;
  }
};

/**
 * Lắng nghe danh sách các ngày điểm danh đã đăng ký của Niên khóa
 */
export const subscribeAttendanceDatesList = (yearId, callback) => {
  if (!yearId) return () => {};
  const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_dates');
  return onSnapshot(docRef, (snap) => {
    if (snap.exists() && Array.isArray(snap.data()?.dates)) {
      callback(snap.data().dates);
    } else {
      callback([]);
    }
  }, (err) => {
    console.error('Lỗi lắng nghe danh sách ngày điểm danh:', err);
    callback([]);
  });
};

/**
 * Lưu danh sách các ngày có điểm danh vào Niên khóa
 */
export const saveAttendanceDatesList = async (yearId, datesArray) => {
  try {
    if (!yearId) return false;
    const docRef = doc(firestore, `academic_years/${yearId}/settings`, 'attendance_dates');
    await setDoc(docRef, {
      dates: Array.from(new Set(datesArray)).sort(),
      updatedAt: Timestamp.now()
    }, { merge: true });
    return true;
  } catch (error) {
    console.error('Lỗi lưu danh sách ngày điểm danh:', error);
    return false;
  }
};

// ====================================================================
// 🎁 BỘ HÀM QUẢN LÝ QUÀ TẶNG GIÁO LÝ VIÊN (SINH NHẬT & SỰ KIỆN)
// ====================================================================

/**
 * 1. Lấy danh sách sự kiện quà tặng
 */
export const fetchGiftEvents = async () => {
  try {
    const col = collection(firestore, 'gift_events');
    const snap = await getDocs(col);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.error('Lỗi khi tải danh sách sự kiện quà:', err);
    return [];
  }
};

/**
 * 2. Lưu / Tạo mới sự kiện quà tặng (Admin)
 */
export const saveGiftEvent = async (eventData) => {
  try {
    if (!eventData || !eventData.id) return { success: false, message: 'Thiếu ID sự kiện' };
    const docRef = doc(firestore, 'gift_events', eventData.id);
    await setDoc(docRef, {
      ...eventData,
      updatedAt: Timestamp.now()
    }, { merge: true });
    return { success: true };
  } catch (err) {
    console.error('Lỗi lưu sự kiện quà:', err);
    return { success: false, message: err.message };
  }
};

/**
 * 3. Xóa sự kiện quà tặng
 */
export const deleteGiftEvent = async (eventId) => {
  try {
    await deleteDoc(doc(firestore, 'gift_events', eventId));
    return { success: true };
  } catch (err) {
    return { success: false, message: err.message };
  }
};

/**
 * 4. Lấy thông tin món quà đã chốt của 1 GLV trong sự kiện
 */
export const fetchCatechistGiftRegistration = async (eventId, uid) => {
  try {
    if (!eventId || !uid) return null;
    const docRef = doc(firestore, `gift_registrations/${eventId}/catechists`, uid);
    const snap = await getDoc(docRef);
    if (snap.exists()) return snap.data();
    return null;
  } catch (err) {
    console.error('Lỗi tải đăng ký quà GLV:', err);
    return null;
  }
};

/**
 * 5. Lưu lựa chọn chốt quà của GLV kèm lời chúc
 */
export const saveCatechistGiftRegistration = async (eventId, uid, data) => {
  try {
    if (!eventId || !uid) return { success: false, message: 'Thiếu thông tin' };
    const docRef = doc(firestore, `gift_registrations/${eventId}/catechists`, uid);
    await setDoc(docRef, {
      ...data,
      updatedAt: Timestamp.now()
    }, { merge: true });
    return { success: true };
  } catch (err) {
    console.error('Lỗi lưu đăng ký quà:', err);
    return { success: false, message: err.message };
  }
};

/**
 * 6. Lấy tất cả các món quà đã chốt của sự kiện (Dành cho Admin)
 */
export const fetchAllGiftRegistrations = async (eventId) => {
  try {
    if (!eventId) return {};
    const col = collection(firestore, `gift_registrations/${eventId}/catechists`);
    const snap = await getDocs(col);
    const result = {};
    snap.docs.forEach(d => {
      result[d.id] = d.data();
    });
    return result;
  } catch (err) {
    console.error('Lỗi tải tất cả đăng ký quà:', err);
    return {};
  }
};

/**
 * 7. Lấy danh sách quà tự tạo riêng của GLV
 */
export const fetchUserCustomGifts = async (uid) => {
  try {
    if (!uid) return [];
    const docRef = doc(firestore, 'custom_gifts', uid);
    const snap = await getDoc(docRef);
    if (snap.exists() && Array.isArray(snap.data()?.gifts)) {
      return snap.data().gifts;
    }
    return [];
  } catch (err) {
    console.error('Lỗi tải quà tự tạo:', err);
    return [];
  }
};

/**
 * 8. Lưu danh sách quà tự tạo riêng của GLV
 */
export const saveUserCustomGifts = async (uid, gifts) => {
  try {
    if (!uid) return { success: false };
    const docRef = doc(firestore, 'custom_gifts', uid);
    await setDoc(docRef, {
      uid,
      gifts: gifts || [],
      updatedAt: Timestamp.now()
    }, { merge: true });
    return { success: true };
  } catch (err) {
    console.error('Lỗi lưu quà tự tạo:', err);
    return { success: false };
  }
};

/**
 * Lấy toàn bộ danh sách quà tự tạo của tất cả Giáo lý viên
 */
export const fetchAllUserCustomGifts = async () => {
  try {
    const col = collection(firestore, 'custom_gifts');
    const snap = await getDocs(col);
    const result = {};
    snap.docs.forEach(d => {
      result[d.id] = d.data().gifts || [];
    });
    return result;
  } catch (err) {
    console.error('Lỗi tải danh sách quà tự thêm của tất cả GLV:', err);
    return {};
  }
};

// ====================================================================
// 🤝 BỘ HÀM QUẢN LÝ PHÂN CÔNG GIÁO LÝ VIÊN ĐI PHỤ LỚP (REALTIME)
// ====================================================================

/**
 * 1. Lắng nghe toàn bộ danh sách phân công phụ lớp của Niên khóa (Dành cho Admin)
 */
export const subscribeAllSubstituteAssignments = (yearId, callback) => {
  if (!yearId) return () => {};
  const colRef = collection(firestore, `academic_years/${yearId}/substitute_assignments`);
  return onSnapshot(colRef, (snap) => {
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    callback(list);
  }, (err) => {
    console.error('Lỗi lắng nghe phân công phụ lớp:', err);
    callback([]);
  });
};

/**
 * 2. Lắng nghe thông tin phân công phụ lớp của 1 GLV cụ thể (Dành cho QRScannerClass)
 */
export const subscribeCatechistSubstitute = (yearId, uid, callback) => {
  if (!yearId || !uid) return () => {};
  const docRef = doc(firestore, `academic_years/${yearId}/substitute_assignments`, uid);
  return onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback(snap.data());
    } else {
      callback(null);
    }
  }, (err) => {
    console.error('Lỗi lắng nghe phụ lớp của GLV:', err);
    callback(null);
  });
};

/**
 * 3. Lưu / Cập nhật phân công phụ lớp cho một Giáo lý viên
 */
export const saveSubstituteAssignment = async (yearId, uid, payload) => {
  try {
    if (!yearId || !uid) return { success: false, message: 'Thiếu thông tin nhận diện' };
    const docRef = doc(firestore, `academic_years/${yearId}/substitute_assignments`, uid);
    await setDoc(docRef, {
      catechistUid: uid,
      holyName: payload.holyName || '',
      fullName: payload.fullName || '',
      idCode: payload.idCode || '',
      primaryClassName: payload.primaryClassName || '',
      assignedClasses: payload.assignedClasses || [], // Mảng [{ classId, className }]
      assignedDate: payload.assignedDate || new Date().toLocaleDateString('sv-SE'),
      notes: payload.notes || '',
      updatedAt: Timestamp.now(),
      updatedBy: payload.updatedBy || 'Admin'
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Lỗi lưu phân công phụ lớp:', error);
    return { success: false, message: error.message };
  }
};

/**
 * 4. Xóa / Thu hồi toàn bộ phân công phụ lớp của một Giáo lý viên
 */
export const deleteSubstituteAssignment = async (yearId, uid) => {
  try {
    if (!yearId || !uid) return { success: false, message: 'Thiếu thông tin nhận diện' };
    const docRef = doc(firestore, `academic_years/${yearId}/substitute_assignments`, uid);
    await deleteDoc(docRef);
    return { success: true };
  } catch (error) {
    console.error('Lỗi xóa phân công phụ lớp:', error);
    return { success: false, message: error.message };
  }
};